import { render, staticRenderFns } from "./tabInfo.vue?vue&type=template&id=8722f166&scoped=true"
import script from "./tabInfo.vue?vue&type=script&lang=js"
export * from "./tabInfo.vue?vue&type=script&lang=js"
import style0 from "./tabInfo.vue?vue&type=style&index=0&id=8722f166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8722f166",
  null
  
)

export default component.exports